export default __webpack_public_path__ + "static/media/arrowbottom.24bccb28.svg";